import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-users",
  "use": "svg_menu-users-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 14\" id=\"svg_menu-users\"><path d=\"M15 8c2.33 0 7 1.17 7 3.5V14h-6v-2.5c0-1.5-.81-2.61-1.96-3.45L15 8zM7 8c2.33 0 7 1.17 7 3.5V14H0v-2.5C0 9.17 4.67 8 7 8zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm8 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol